export const checkDynamicPriceEnabled = (source) => {
    if(source.includes('poster') || source.includes('document') || source.includes('csv') || source.includes('booklet') || source.includes('loose-sheet-v2')) {
        return true;
    }
    return false;
};

export default {
    checkDynamicPriceEnabled,
};